module.exports = __webpack_public_path__ + "static/important-credit-cards-a3ae4a036ae7eee51174bc463bf3828e.jpg";